import {
  CHANGE_SHOW_CATEGORY, SET_IMPORTANT_COURSE,
  SET_COURSE_GROUPS, SET_SELECTED_GROUP_COURSE, SET_SELECTED_ACTIVE
} from './mutation-types'

export default {
  [CHANGE_SHOW_CATEGORY] (state, data) {
    state.showCategory = data
  },
  [SET_IMPORTANT_COURSE] (state, data) {
    state.important_course = data
  },
  [SET_COURSE_GROUPS] (state, data) {
    state.course_groups = data
  },
  [SET_SELECTED_GROUP_COURSE] (state, data) {
    state.selected_group_courses = data
    const selectedId = state.course_groups.find(c => c.is_selected).course_group_id
    state.selected_group_list[selectedId] = data
  },
  [SET_SELECTED_ACTIVE] (state, { course_group_id }) {
    state.course_groups = state.course_groups.map((c) => {
      c.is_selected = c.course_group_id === course_group_id
      return c
    })
  }
}
